module.exports = __webpack_public_path__ + "static/media/streak-fire.ae850807.png";